import { render, staticRenderFns } from "./join.vue?vue&type=template&id=efa20dae&scoped=true"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"
import style0 from "./join.vue?vue&type=style&index=0&id=efa20dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa20dae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JoinPreview: require('/web/components/join/JoinPreview.vue').default,JoinForm: require('/web/components/join/JoinForm.vue').default,JoinSuccess: require('/web/components/join/JoinSuccess.vue').default})
